export interface PixelMilimetros {
	pixeles: number
}
